/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GoodMediumBad {
    GOOD = 'GOOD',
    MEDIUM = 'MEDIUM',
    BAD = 'BAD',
}
